// Textos del panel de calculadoras (src/components/Calculadoras.js).
// Mismas claves en los tres idiomas; el español es el texto de referencia.
export const calculadoras = {
  es: {
    calcTitulo: 'Calculadoras financieras',
    calcIntro: 'Herramientas para proyectar, comparar y decidir. Son simulaciones: no tocan tus datos.',
    calcAbrir: 'Abrir calculadora',
    calcVolver: '← Todas las calculadoras',
    calcCompuestoTitulo: 'Interés compuesto',
    calcCompuestoDesc: 'Proyecta el crecimiento de tus inversiones con aportaciones periódicas, inflación, retiradas y un modelo de rentabilidad fija o volátil con rango de escenarios.',
    calcHipotecaTitulo: 'Hipoteca y préstamos',
    calcHipotecaDesc: 'Calcula la cuota, los intereses totales y cuánto te ahorras en tiempo y dinero con pagos anticipados, mensuales o puntuales.',
    calcFireTitulo: 'Independencia financiera',
    calcFireDesc: 'Averigua el capital que necesitas para vivir de tus inversiones, cuántos años te faltan y el punto a partir del cual podrías dejar de aportar.',
    calcVpnTitulo: 'VPN / TIR',
    calcVpnDesc: 'Valora un proyecto o una inversión por sus flujos de caja: valor presente neto y tasa interna de retorno.',
    calcDcaTitulo: 'Precio medio (DCA)',
    calcDcaDesc: 'Anticipa el nuevo precio medio y el coste total de tu posición antes de hacer la siguiente compra, a distintos precios.',
    calcIntrinsecoTitulo: 'Valor intrínseco',
    calcIntrinsecoDesc: 'Estima el valor de una acción por descuento de flujos de caja, con margen de seguridad, crecimiento implícito y matriz de sensibilidad.',
    // Interés compuesto
    ciInversionInicial: 'Inversión inicial (€)',
    ciAportacion: 'Aportación (€)',
    ciFrecuencia: 'Frecuencia',
    ciFrecuenciaAyuda: 'Se agrupan por mes: 365 aportaciones al año si es diaria, 52 si es semanal y 26 si es quincenal.',
    ciDiaria: 'Diaria',
    ciSemanal: 'Semanal',
    ciQuincenal: 'Quincenal',
    ciMensual: 'Mensual',
    ciTrimestral: 'Trimestral',
    ciAnual: 'Anual',
    ciRentabilidad: 'Rentabilidad anual esperada (%)',
    ciCapitalizacion: 'Capitalización',
    ciAnios: 'Años',
    ciInflacion: 'Inflación anual (%)',
    ciInflacionAyuda: 'Para ver el valor final en euros de hoy. Las retiradas también suben con ella.',
    ciModelo: 'Modelo de rentabilidad',
    ciFijo: 'Fija cada año',
    ciVolatil: 'Volátil (simulación)',
    ciVolatilidad: 'Volatilidad anual (%)',
    ciTrayectoria: 'Trayectoria',
    ciAleatorizar: 'Otra trayectoria',
    ciAportaciones: 'Aportaciones',
    ciConstantes: 'Constantes',
    ciCrecientes: 'Crecen cada año',
    ciCrecimientoAportacion: 'Crecimiento anual de la aportación (%)',
    ciDetener: 'Dejar de aportar tras (años)',
    ciDetenerAyuda: '0 = aportar durante todo el periodo',
    ciRetiradas: 'Fase de retiradas (vivir del capital)',
    ciRetiradaDesde: 'Retirar a partir del año',
    ciRetiradaMensual: 'Retirada mensual (€)',
    ciRetiradaAyuda: 'En euros de hoy: se actualiza con la inflación.',
    ciValorFinal: 'Valor final',
    ciValorFinalReal: 'En euros de hoy',
    ciValorFinalMediana: 'Valor final (mediana de {n} simulaciones)',
    ciMedianaCorta: 'mediana',
    ciTrayectoriaMostrada: 'Trayectoria mostrada en el gráfico',
    ciProbAgotar: 'Simulaciones en las que el capital se agota',
    ciMediana: 'Mediana de {n} simulaciones',
    ciPesimista: 'Pesimista (10 %)',
    ciOptimista: 'Optimista (90 %)',
    ciTotalInvertido: 'Total invertido',
    ciAportadoTotal: 'Aportaciones',
    ciInicialPct: 'Capital inicial sobre el valor final',
    ciGananciaTotal: 'Ganancia total',
    ciGananciaPct: 'Ganancia sobre lo invertido',
    ciTirInversion: 'Rentabilidad anualizada obtenida',
    ciRetiradasTotal: 'Retiradas totales',
    ciCruce: 'La ganancia supera lo invertido',
    ciCruceAnio: 'en el año {n}',
    ciCruceNunca: 'no ocurre en el periodo',
    ciAgotado: 'Con estas retiradas el capital se agota en el año {n}.',
    ciNota: 'Simulación orientativa: no incluye impuestos ni comisiones. En el modelo volátil la rentabilidad de cada mes es aleatoria con la media y la volatilidad indicadas; el rango sale de 200 simulaciones.',
    ciGrafico: 'Evolución del capital',
    ciLeyendaTotal: 'Capital',
    ciLeyendaTrayectoria: 'Trayectoria mostrada',
    ciLeyendaAportado: 'Total invertido',
    ciLeyendaP10: 'Pesimista (10 %)',
    ciLeyendaP90: 'Optimista (90 %)',
    ciLeyendaMediana: 'Mediana',
    ciTabla: 'Detalle año a año',
    ciCadaCinco: 'Cada 5 años',
    ciColAnio: 'Año',
    ciColAportado: 'Aportado en el año',
    ciColAportadoAcum: 'Invertido acumulado',
    ciColInteresAnio: 'Rendimiento del año',
    ciColInteresAcum: 'Rendimiento acumulado',
    ciColRetiradas: 'Retiradas',
    ciColBalance: 'Capital',
    // Hipoteca
    hiImporte: 'Importe del préstamo (€)',
    hiInteres: 'Tipo de interés anual (%)',
    hiPlazo: 'Plazo (años)',
    hiAmortizarAntes: 'Amortización anticipada (opcional)',
    hiExtraMensual: 'Pago extra cada mes (€)',
    hiExtraUnico: 'Pago extra único (€)',
    hiExtraUnicoMes: 'En el mes nº',
    hiCuota: 'Cuota mensual',
    hiTotalIntereses: 'Intereses totales',
    hiTotalPagado: 'Total pagado',
    hiDuracion: 'Duración',
    hiAniosMeses: '{a} años y {m} meses',
    hiConExtras: 'Con los pagos extra',
    hiAhorroIntereses: 'Intereses que te ahorras',
    hiMesesMenos: '{n} meses menos',
    hiGrafico: 'Capital pendiente por año',
    hiLeyendaBase: 'Sin pagos extra',
    hiLeyendaExtras: 'Con pagos extra',
    hiReparto: 'Qué pagas el primer año',
    hiInteresParte: 'Intereses',
    hiCapitalParte: 'Capital',
    hiNota: 'Sistema francés (cuota constante). Para registrar un préstamo real y verlo en tu presupuesto, usa la pestaña Préstamos.',
    // FIRE
    fiGastoAnual: 'Gasto anual previsto (€)',
    fiTasaRetirada: 'Tasa de retirada segura (%)',
    fiPatrimonio: 'Patrimonio invertido hoy (€)',
    fiAportacionAnual: 'Aportación anual (€)',
    fiRentabilidad: 'Rentabilidad real esperada (%)',
    fiEdad: 'Edad actual',
    fiEdadObjetivo: 'Edad objetivo',
    fiNumero: 'Tu número FIRE',
    fiNumeroDesc: 'Capital del que puedes retirar tu gasto anual ({tasa} % al año) sin agotarlo.',
    fiProgreso: 'Progreso',
    fiAniosHasta: 'Años hasta alcanzarlo',
    fiEdadFire: 'A los {edad} años',
    fiYaAlcanzado: 'Ya alcanzado',
    fiNoAlcanzado: 'No se alcanza en 60 años con estos datos.',
    fiCoast: 'Coast FIRE',
    fiCoastDesc: 'Capital que, sin aportar nada más, crecería hasta tu número FIRE a los {edad} años.',
    fiCoastAlcanzado: 'Alcanzado: podrías dejar de aportar hoy y llegar igual.',
    fiCoastFalta: 'Te faltan {x} para alcanzarlo.',
    fiGrafico: 'Patrimonio proyectado frente al objetivo',
    fiLeyendaPatrimonio: 'Patrimonio',
    fiLeyendaObjetivo: 'Número FIRE',
    fiNota: 'Usa una rentabilidad real (descontada la inflación) para que el gasto anual esté en euros de hoy. La regla del 4 % es una referencia, no una garantía.',
    // DCA
    dcUnidades: 'Unidades que tienes',
    dcPrecioMedio: 'Precio medio actual (€)',
    dcNuevaAportacion: 'Nueva compra (€)',
    dcPrecioActual: 'Precio actual (€)',
    dcComision: 'Comisión de la compra (€)',
    dcNuevasUnidades: 'Unidades que compras',
    dcUnidadesTotal: 'Unidades totales',
    dcNuevoPrecioMedio: 'Nuevo precio medio',
    dcVariacion: 'Variación del precio medio',
    dcCosteTotal: 'Coste total de la posición',
    dcValorActual: 'Valor a precio actual',
    dcResultado: 'Resultado latente',
    dcEscenarios: '¿Y si el precio fuera otro?',
    dcPrecioCompra: 'Precio de compra',
    dcNota: 'Comprar por debajo de tu precio medio lo baja; por encima, lo sube. La comisión se reparte entre las unidades compradas.',
    // Valor intrínseco
    viFcf: 'Flujo de caja libre por acción (€)',
    viFcfAyuda: 'Último año. Puedes usar el beneficio por acción si no lo conoces.',
    viCrecimiento1: 'Crecimiento años 1-5 (%)',
    viCrecimiento2: 'Crecimiento años 6-10 (%)',
    viTerminal: 'Crecimiento a perpetuidad (%)',
    viDescuento: 'Tasa de descuento (%)',
    viDescuentoCorto: 'Descuento',
    viCrecimientoCorto: 'crecimiento 1-5',
    viCajaNeta: 'Caja neta por acción (€)',
    viCajaAyuda: 'Negativa si la empresa tiene deuda neta.',
    viPrecio: 'Precio actual (€)',
    viValor: 'Valor intrínseco por acción',
    viMargen: 'Margen de seguridad',
    viInfravalorada: 'Cotiza un {x} % por debajo de su valor.',
    viSobrevalorada: 'Cotiza un {x} % por encima de su valor.',
    viValorFlujos: 'Valor presente de los flujos (10 años)',
    viValorTerminal: 'Valor presente del valor terminal',
    viDelValor: 'del valor',
    viCrecimientoImplicito: 'Crecimiento implícito en el precio',
    viCrecimientoImplicitoDesc: 'Crecimiento anual (años 1-10) que justificaría el precio actual.',
    viMatriz: 'Matriz de sensibilidad (valor por acción)',
    viMatrizDesc: 'Filas: tasa de descuento. Columnas: crecimiento de los años 1-5. En verde, por encima del precio actual.',
    viNota: 'Modelo DCF simplificado de dos etapas con valor terminal (Gordon). Es tan bueno como sus supuestos: prueba varios escenarios antes de decidir.',
    viInvalido: 'La tasa de descuento debe ser mayor que el crecimiento a perpetuidad.'
  },
  en: {
    calcTitulo: 'Financial calculators',
    calcIntro: 'Tools to project, compare and decide. They are simulations: they do not touch your data.',
    calcAbrir: 'Open calculator',
    calcVolver: '← All calculators',
    calcCompuestoTitulo: 'Compound interest',
    calcCompuestoDesc: 'Project the growth of your investments with periodic contributions, inflation, withdrawals and a fixed or volatile return model with a range of scenarios.',
    calcHipotecaTitulo: 'Mortgage & loans',
    calcHipotecaDesc: 'Calculate the payment, total interest and how much time and money you save with early repayments, monthly or one-off.',
    calcFireTitulo: 'Financial independence',
    calcFireDesc: 'Find out the capital you need to live off your investments, how many years are left and the point from which you could stop contributing.',
    calcVpnTitulo: 'NPV / IRR',
    calcVpnDesc: 'Value a project or investment by its cash flows: net present value and internal rate of return.',
    calcDcaTitulo: 'Average price (DCA)',
    calcDcaDesc: 'Anticipate the new average price and total cost of your position before your next purchase, at different prices.',
    calcIntrinsecoTitulo: 'Intrinsic value',
    calcIntrinsecoDesc: 'Estimate the value of a share by discounting cash flows, with margin of safety, implied growth and a sensitivity matrix.',
    ciInversionInicial: 'Initial investment (€)',
    ciAportacion: 'Contribution (€)',
    ciFrecuencia: 'Frequency',
    ciFrecuenciaAyuda: 'Grouped by month: 365 contributions a year if daily, 52 if weekly and 26 if fortnightly.',
    ciDiaria: 'Daily',
    ciSemanal: 'Weekly',
    ciQuincenal: 'Fortnightly',
    ciMensual: 'Monthly',
    ciTrimestral: 'Quarterly',
    ciAnual: 'Annual',
    ciRentabilidad: 'Expected annual return (%)',
    ciCapitalizacion: 'Compounding',
    ciAnios: 'Years',
    ciInflacion: 'Annual inflation (%)',
    ciInflacionAyuda: "To see the final value in today's euros. Withdrawals rise with it too.",
    ciModelo: 'Return model',
    ciFijo: 'Fixed every year',
    ciVolatil: 'Volatile (simulation)',
    ciVolatilidad: 'Annual volatility (%)',
    ciTrayectoria: 'Path',
    ciAleatorizar: 'Another path',
    ciAportaciones: 'Contributions',
    ciConstantes: 'Constant',
    ciCrecientes: 'Growing every year',
    ciCrecimientoAportacion: 'Annual contribution growth (%)',
    ciDetener: 'Stop contributing after (years)',
    ciDetenerAyuda: '0 = contribute for the whole period',
    ciRetiradas: 'Withdrawal phase (living off the capital)',
    ciRetiradaDesde: 'Withdraw from year',
    ciRetiradaMensual: 'Monthly withdrawal (€)',
    ciRetiradaAyuda: "In today's euros: adjusted for inflation.",
    ciValorFinal: 'Final value',
    ciValorFinalReal: "In today's euros",
    ciValorFinalMediana: 'Final value (median of {n} simulations)',
    ciMedianaCorta: 'median',
    ciTrayectoriaMostrada: 'Path shown in the chart',
    ciProbAgotar: 'Simulations in which the capital runs out',
    ciMediana: 'Median of {n} simulations',
    ciPesimista: 'Pessimistic (10%)',
    ciOptimista: 'Optimistic (90%)',
    ciTotalInvertido: 'Total invested',
    ciAportadoTotal: 'Contributions',
    ciInicialPct: 'Initial capital over final value',
    ciGananciaTotal: 'Total gain',
    ciGananciaPct: 'Gain over invested',
    ciTirInversion: 'Annualised return achieved',
    ciRetiradasTotal: 'Total withdrawals',
    ciCruce: 'Gains exceed the amount invested',
    ciCruceAnio: 'in year {n}',
    ciCruceNunca: 'does not happen in the period',
    ciAgotado: 'With these withdrawals the capital runs out in year {n}.',
    ciNota: 'Indicative simulation: it does not include taxes or fees. In the volatile model each month\'s return is random with the given mean and volatility; the range comes from 200 simulations.',
    ciGrafico: 'Capital over time',
    ciLeyendaTotal: 'Capital',
    ciLeyendaTrayectoria: 'Path shown',
    ciLeyendaAportado: 'Total invested',
    ciLeyendaP10: 'Pessimistic (10%)',
    ciLeyendaP90: 'Optimistic (90%)',
    ciLeyendaMediana: 'Median',
    ciTabla: 'Year by year',
    ciCadaCinco: 'Every 5 years',
    ciColAnio: 'Year',
    ciColAportado: 'Contributed in year',
    ciColAportadoAcum: 'Cumulative invested',
    ciColInteresAnio: 'Return in year',
    ciColInteresAcum: 'Cumulative return',
    ciColRetiradas: 'Withdrawals',
    ciColBalance: 'Capital',
    hiImporte: 'Loan amount (€)',
    hiInteres: 'Annual interest rate (%)',
    hiPlazo: 'Term (years)',
    hiAmortizarAntes: 'Early repayment (optional)',
    hiExtraMensual: 'Extra payment every month (€)',
    hiExtraUnico: 'One-off extra payment (€)',
    hiExtraUnicoMes: 'In month no.',
    hiCuota: 'Monthly payment',
    hiTotalIntereses: 'Total interest',
    hiTotalPagado: 'Total paid',
    hiDuracion: 'Duration',
    hiAniosMeses: '{a} years and {m} months',
    hiConExtras: 'With the extra payments',
    hiAhorroIntereses: 'Interest you save',
    hiMesesMenos: '{n} months less',
    hiGrafico: 'Outstanding balance per year',
    hiLeyendaBase: 'Without extra payments',
    hiLeyendaExtras: 'With extra payments',
    hiReparto: 'What you pay in the first year',
    hiInteresParte: 'Interest',
    hiCapitalParte: 'Principal',
    hiNota: 'French system (constant payment). To record a real loan and see it in your budget, use the Loans tab.',
    fiGastoAnual: 'Expected annual expenses (€)',
    fiTasaRetirada: 'Safe withdrawal rate (%)',
    fiPatrimonio: 'Invested net worth today (€)',
    fiAportacionAnual: 'Annual contribution (€)',
    fiRentabilidad: 'Expected real return (%)',
    fiEdad: 'Current age',
    fiEdadObjetivo: 'Target age',
    fiNumero: 'Your FIRE number',
    fiNumeroDesc: 'Capital from which you can withdraw your annual expenses ({tasa}% a year) without depleting it.',
    fiProgreso: 'Progress',
    fiAniosHasta: 'Years until you reach it',
    fiEdadFire: 'At age {edad}',
    fiYaAlcanzado: 'Already reached',
    fiNoAlcanzado: 'Not reached within 60 years with these inputs.',
    fiCoast: 'Coast FIRE',
    fiCoastDesc: 'Capital that, without contributing anything else, would grow to your FIRE number by age {edad}.',
    fiCoastAlcanzado: 'Reached: you could stop contributing today and still get there.',
    fiCoastFalta: 'You need {x} more to reach it.',
    fiGrafico: 'Projected net worth vs. target',
    fiLeyendaPatrimonio: 'Net worth',
    fiLeyendaObjetivo: 'FIRE number',
    fiNota: "Use a real return (net of inflation) so that annual expenses are in today's euros. The 4% rule is a reference, not a guarantee.",
    dcUnidades: 'Units you hold',
    dcPrecioMedio: 'Current average price (€)',
    dcNuevaAportacion: 'New purchase (€)',
    dcPrecioActual: 'Current price (€)',
    dcComision: 'Purchase fee (€)',
    dcNuevasUnidades: 'Units you buy',
    dcUnidadesTotal: 'Total units',
    dcNuevoPrecioMedio: 'New average price',
    dcVariacion: 'Change in average price',
    dcCosteTotal: 'Total cost of the position',
    dcValorActual: 'Value at current price',
    dcResultado: 'Unrealised result',
    dcEscenarios: 'What if the price were different?',
    dcPrecioCompra: 'Purchase price',
    dcNota: 'Buying below your average price lowers it; above, it raises it. The fee is spread over the units bought.',
    viFcf: 'Free cash flow per share (€)',
    viFcfAyuda: 'Last year. You can use earnings per share if you do not know it.',
    viCrecimiento1: 'Growth years 1-5 (%)',
    viCrecimiento2: 'Growth years 6-10 (%)',
    viTerminal: 'Perpetual growth (%)',
    viDescuento: 'Discount rate (%)',
    viDescuentoCorto: 'Discount',
    viCrecimientoCorto: 'growth 1-5',
    viCajaNeta: 'Net cash per share (€)',
    viCajaAyuda: 'Negative if the company has net debt.',
    viPrecio: 'Current price (€)',
    viValor: 'Intrinsic value per share',
    viMargen: 'Margin of safety',
    viInfravalorada: 'It trades {x}% below its value.',
    viSobrevalorada: 'It trades {x}% above its value.',
    viValorFlujos: 'Present value of cash flows (10 years)',
    viValorTerminal: 'Present value of terminal value',
    viDelValor: 'of the value',
    viCrecimientoImplicito: 'Growth implied by the price',
    viCrecimientoImplicitoDesc: 'Annual growth (years 1-10) that would justify the current price.',
    viMatriz: 'Sensitivity matrix (value per share)',
    viMatrizDesc: 'Rows: discount rate. Columns: growth in years 1-5. Green means above the current price.',
    viNota: 'Simplified two-stage DCF with terminal value (Gordon). It is only as good as its assumptions: try several scenarios before deciding.',
    viInvalido: 'The discount rate must be higher than the perpetual growth rate.'
  },
  de: {
    calcTitulo: 'Finanzrechner',
    calcIntro: 'Werkzeuge zum Planen, Vergleichen und Entscheiden. Es sind Simulationen: Ihre Daten werden nicht verändert.',
    calcAbrir: 'Rechner öffnen',
    calcVolver: '← Alle Rechner',
    calcCompuestoTitulo: 'Zinseszins',
    calcCompuestoDesc: 'Projizieren Sie das Wachstum Ihrer Anlagen mit regelmäßigen Einzahlungen, Inflation, Entnahmen und einem festen oder volatilen Renditemodell mit Szenariobandbreite.',
    calcHipotecaTitulo: 'Hypothek & Kredite',
    calcHipotecaDesc: 'Berechnen Sie die Rate, die Gesamtzinsen und wie viel Zeit und Geld Sie mit Sondertilgungen sparen, monatlich oder einmalig.',
    calcFireTitulo: 'Finanzielle Unabhängigkeit',
    calcFireDesc: 'Ermitteln Sie das Kapital, das Sie brauchen, um von Ihren Anlagen zu leben, wie viele Jahre noch fehlen und ab wann Sie aufhören könnten einzuzahlen.',
    calcVpnTitulo: 'Kapitalwert / IRR',
    calcVpnDesc: 'Bewerten Sie ein Projekt oder eine Investition anhand ihrer Cashflows: Kapitalwert und interner Zinsfuß.',
    calcDcaTitulo: 'Durchschnittspreis (DCA)',
    calcDcaDesc: 'Sehen Sie vor dem nächsten Kauf den neuen Durchschnittspreis und die Gesamtkosten Ihrer Position zu verschiedenen Kursen.',
    calcIntrinsecoTitulo: 'Innerer Wert',
    calcIntrinsecoDesc: 'Schätzen Sie den Wert einer Aktie per Discounted Cashflow, mit Sicherheitsmarge, implizitem Wachstum und Sensitivitätsmatrix.',
    ciInversionInicial: 'Anfangsinvestition (€)',
    ciAportacion: 'Einzahlung (€)',
    ciFrecuencia: 'Häufigkeit',
    ciFrecuenciaAyuda: 'Monatlich zusammengefasst: 365 Einzahlungen pro Jahr bei täglich, 52 bei wöchentlich und 26 bei zweiwöchentlich.',
    ciDiaria: 'Täglich',
    ciSemanal: 'Wöchentlich',
    ciQuincenal: 'Alle zwei Wochen',
    ciMensual: 'Monatlich',
    ciTrimestral: 'Vierteljährlich',
    ciAnual: 'Jährlich',
    ciRentabilidad: 'Erwartete Jahresrendite (%)',
    ciCapitalizacion: 'Verzinsung',
    ciAnios: 'Jahre',
    ciInflacion: 'Jährliche Inflation (%)',
    ciInflacionAyuda: 'Um den Endwert in heutigen Euro zu sehen. Entnahmen steigen ebenfalls damit.',
    ciModelo: 'Renditemodell',
    ciFijo: 'Jedes Jahr fest',
    ciVolatil: 'Volatil (Simulation)',
    ciVolatilidad: 'Jährliche Volatilität (%)',
    ciTrayectoria: 'Verlauf',
    ciAleatorizar: 'Anderer Verlauf',
    ciAportaciones: 'Einzahlungen',
    ciConstantes: 'Konstant',
    ciCrecientes: 'Jährlich steigend',
    ciCrecimientoAportacion: 'Jährliches Wachstum der Einzahlung (%)',
    ciDetener: 'Einzahlungen stoppen nach (Jahren)',
    ciDetenerAyuda: '0 = während des gesamten Zeitraums einzahlen',
    ciRetiradas: 'Entnahmephase (vom Kapital leben)',
    ciRetiradaDesde: 'Entnahme ab Jahr',
    ciRetiradaMensual: 'Monatliche Entnahme (€)',
    ciRetiradaAyuda: 'In heutigen Euro: wird mit der Inflation angepasst.',
    ciValorFinal: 'Endwert',
    ciValorFinalReal: 'In heutigen Euro',
    ciValorFinalMediana: 'Endwert (Median aus {n} Simulationen)',
    ciMedianaCorta: 'Median',
    ciTrayectoriaMostrada: 'Im Diagramm gezeigter Verlauf',
    ciProbAgotar: 'Simulationen, in denen das Kapital aufgebraucht wird',
    ciMediana: 'Median aus {n} Simulationen',
    ciPesimista: 'Pessimistisch (10 %)',
    ciOptimista: 'Optimistisch (90 %)',
    ciTotalInvertido: 'Insgesamt investiert',
    ciAportadoTotal: 'Einzahlungen',
    ciInicialPct: 'Anfangskapital am Endwert',
    ciGananciaTotal: 'Gesamtgewinn',
    ciGananciaPct: 'Gewinn auf das Investierte',
    ciTirInversion: 'Erzielte annualisierte Rendite',
    ciRetiradasTotal: 'Entnahmen gesamt',
    ciCruce: 'Gewinn übersteigt das Investierte',
    ciCruceAnio: 'im Jahr {n}',
    ciCruceNunca: 'tritt im Zeitraum nicht ein',
    ciAgotado: 'Mit diesen Entnahmen ist das Kapital im Jahr {n} aufgebraucht.',
    ciNota: 'Orientierende Simulation: ohne Steuern und Gebühren. Im volatilen Modell ist die Monatsrendite zufällig mit der angegebenen mittleren Rendite und Volatilität; die Bandbreite stammt aus 200 Simulationen.',
    ciGrafico: 'Kapitalentwicklung',
    ciLeyendaTotal: 'Kapital',
    ciLeyendaTrayectoria: 'Gezeigter Verlauf',
    ciLeyendaAportado: 'Insgesamt investiert',
    ciLeyendaP10: 'Pessimistisch (10 %)',
    ciLeyendaP90: 'Optimistisch (90 %)',
    ciLeyendaMediana: 'Median',
    ciTabla: 'Jahr für Jahr',
    ciCadaCinco: 'Alle 5 Jahre',
    ciColAnio: 'Jahr',
    ciColAportado: 'Eingezahlt im Jahr',
    ciColAportadoAcum: 'Kumuliert investiert',
    ciColInteresAnio: 'Rendite im Jahr',
    ciColInteresAcum: 'Kumulierte Rendite',
    ciColRetiradas: 'Entnahmen',
    ciColBalance: 'Kapital',
    hiImporte: 'Kreditbetrag (€)',
    hiInteres: 'Jahreszinssatz (%)',
    hiPlazo: 'Laufzeit (Jahre)',
    hiAmortizarAntes: 'Sondertilgung (optional)',
    hiExtraMensual: 'Zusätzliche Zahlung pro Monat (€)',
    hiExtraUnico: 'Einmalige Sondertilgung (€)',
    hiExtraUnicoMes: 'Im Monat Nr.',
    hiCuota: 'Monatsrate',
    hiTotalIntereses: 'Gesamtzinsen',
    hiTotalPagado: 'Insgesamt gezahlt',
    hiDuracion: 'Laufzeit',
    hiAniosMeses: '{a} Jahre und {m} Monate',
    hiConExtras: 'Mit den Sondertilgungen',
    hiAhorroIntereses: 'Gesparte Zinsen',
    hiMesesMenos: '{n} Monate weniger',
    hiGrafico: 'Restschuld pro Jahr',
    hiLeyendaBase: 'Ohne Sondertilgungen',
    hiLeyendaExtras: 'Mit Sondertilgungen',
    hiReparto: 'Was Sie im ersten Jahr zahlen',
    hiInteresParte: 'Zinsen',
    hiCapitalParte: 'Tilgung',
    hiNota: 'Annuitätendarlehen (konstante Rate). Um einen echten Kredit zu erfassen und im Budget zu sehen, nutzen Sie den Reiter Kredite.',
    fiGastoAnual: 'Erwartete Jahresausgaben (€)',
    fiTasaRetirada: 'Sichere Entnahmerate (%)',
    fiPatrimonio: 'Heute investiertes Vermögen (€)',
    fiAportacionAnual: 'Jährliche Einzahlung (€)',
    fiRentabilidad: 'Erwartete reale Rendite (%)',
    fiEdad: 'Aktuelles Alter',
    fiEdadObjetivo: 'Zielalter',
    fiNumero: 'Ihre FIRE-Zahl',
    fiNumeroDesc: 'Kapital, aus dem Sie Ihre Jahresausgaben ({tasa} % pro Jahr) entnehmen können, ohne es aufzubrauchen.',
    fiProgreso: 'Fortschritt',
    fiAniosHasta: 'Jahre bis zum Erreichen',
    fiEdadFire: 'Mit {edad} Jahren',
    fiYaAlcanzado: 'Bereits erreicht',
    fiNoAlcanzado: 'Mit diesen Angaben innerhalb von 60 Jahren nicht erreicht.',
    fiCoast: 'Coast FIRE',
    fiCoastDesc: 'Kapital, das ohne weitere Einzahlungen bis zum Alter von {edad} Jahren auf Ihre FIRE-Zahl anwachsen würde.',
    fiCoastAlcanzado: 'Erreicht: Sie könnten heute aufhören einzuzahlen und kämen trotzdem ans Ziel.',
    fiCoastFalta: 'Es fehlen noch {x}.',
    fiGrafico: 'Prognostiziertes Vermögen vs. Ziel',
    fiLeyendaPatrimonio: 'Vermögen',
    fiLeyendaObjetivo: 'FIRE-Zahl',
    fiNota: 'Verwenden Sie eine reale Rendite (nach Inflation), damit die Jahresausgaben in heutigen Euro bleiben. Die 4-%-Regel ist ein Richtwert, keine Garantie.',
    dcUnidades: 'Gehaltene Einheiten',
    dcPrecioMedio: 'Aktueller Durchschnittspreis (€)',
    dcNuevaAportacion: 'Neuer Kauf (€)',
    dcPrecioActual: 'Aktueller Kurs (€)',
    dcComision: 'Kaufgebühr (€)',
    dcNuevasUnidades: 'Gekaufte Einheiten',
    dcUnidadesTotal: 'Einheiten gesamt',
    dcNuevoPrecioMedio: 'Neuer Durchschnittspreis',
    dcVariacion: 'Änderung des Durchschnittspreises',
    dcCosteTotal: 'Gesamtkosten der Position',
    dcValorActual: 'Wert zum aktuellen Kurs',
    dcResultado: 'Unrealisiertes Ergebnis',
    dcEscenarios: 'Was wäre bei einem anderen Kurs?',
    dcPrecioCompra: 'Kaufkurs',
    dcNota: 'Ein Kauf unter Ihrem Durchschnittspreis senkt ihn; darüber erhöht er ihn. Die Gebühr verteilt sich auf die gekauften Einheiten.',
    viFcf: 'Freier Cashflow je Aktie (€)',
    viFcfAyuda: 'Letztes Jahr. Sie können den Gewinn je Aktie verwenden, wenn Sie ihn nicht kennen.',
    viCrecimiento1: 'Wachstum Jahre 1-5 (%)',
    viCrecimiento2: 'Wachstum Jahre 6-10 (%)',
    viTerminal: 'Ewiges Wachstum (%)',
    viDescuento: 'Diskontsatz (%)',
    viDescuentoCorto: 'Diskont',
    viCrecimientoCorto: 'Wachstum 1-5',
    viCajaNeta: 'Nettokasse je Aktie (€)',
    viCajaAyuda: 'Negativ, wenn das Unternehmen Nettoschulden hat.',
    viPrecio: 'Aktueller Kurs (€)',
    viValor: 'Innerer Wert je Aktie',
    viMargen: 'Sicherheitsmarge',
    viInfravalorada: 'Notiert {x} % unter dem Wert.',
    viSobrevalorada: 'Notiert {x} % über dem Wert.',
    viValorFlujos: 'Barwert der Cashflows (10 Jahre)',
    viValorTerminal: 'Barwert des Endwerts',
    viDelValor: 'des Werts',
    viCrecimientoImplicito: 'Im Kurs implizites Wachstum',
    viCrecimientoImplicitoDesc: 'Jährliches Wachstum (Jahre 1-10), das den aktuellen Kurs rechtfertigen würde.',
    viMatriz: 'Sensitivitätsmatrix (Wert je Aktie)',
    viMatrizDesc: 'Zeilen: Diskontsatz. Spalten: Wachstum der Jahre 1-5. Grün bedeutet über dem aktuellen Kurs.',
    viNota: 'Vereinfachtes zweistufiges DCF-Modell mit Endwert (Gordon). Es ist nur so gut wie seine Annahmen: Prüfen Sie mehrere Szenarien, bevor Sie entscheiden.',
    viInvalido: 'Der Diskontsatz muss höher sein als das ewige Wachstum.'
  }
};
